import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { routes } from './app.routes';
import { coreConfig } from '@core/core.config';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { proveedorInicializadorRutasDinamicas } from '@core/initializers/rutas-dinamicas.initializer';
import { proveedorPrecargarEstadoInicial } from '@core/initializers/precargar-estado-inicial.initializer';
import { proveedorEvaluacionSalidaSesion } from '@core/initializers/evaluar-salida-sesion.initializer';
import { proveedorDeteccionModoTeclado } from '@core/initializers/deteccion-modo-teclado.initializer';
import { proveedorExpiracionAbsolutaSesion } from '@core/initializers/expiracion-absoluta-sesion.initializer';
import { proveedorRestauracionSesion } from '@core/initializers/restauracion-sesion.initializer';
import { proveedorUrlsBanco } from '@core/initializers/urls-banco.initializer';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    proveedorEvaluacionSalidaSesion(),
    proveedorInicializadorRutasDinamicas(),
    proveedorPrecargarEstadoInicial(),
    proveedorDeteccionModoTeclado(),
    proveedorExpiracionAbsolutaSesion(),
    proveedorRestauracionSesion(),
    proveedorUrlsBanco(),
    ...coreConfig.providers,
    provideClientHydration(withEventReplay()),
  ],
};
